export default __webpack_public_path__ + "static/media/aunScreenRecorder.911ac1f2.png";